import React, { createContext, useState, useEffect } from 'react';

/**
 * Contexto simplificado do mapa com apenas os estados essenciais
 * para a nova arquitetura de carregamento de dados GeoJSON.
 */
// eslint-disable-next-line react-refresh/only-export-components
export const MapContext = createContext();

export function MapProvider({ children }) {
  // Estados essenciais para a funcionalidade principal
  const [propertyData, setPropertyData] = useState(null); // Dados da propriedade buscada
  const [geometries, setGeometries] = useState([]); // Geometrias para renderização
  const [themeGeometries, setThemeGeometries] = useState({}); // Geometrias organizadas por tema
  const [loading, setLoading] = useState(false); // Estado de carregamento
  const [error, setError] = useState(null); // Mensagens de erro
  const [propertyCodes, setPropertyCodes] = useState({
    cod_car: null,
    codigo_imo: null,
    filename: null,
  }); // Códigos da propriedade

  // Função para processamento de propriedade (necessária para compatibilidade)
  const [handlePropertyResult, setHandlePropertyResult] = useState(() => () => {});

  // Estados para controle da UI
  const [sidebarOpen, setSidebarOpen] = useState(false); // Controle do sidebar
  const [activeLayers, setActiveLayers] = useState({}); // Estado das camadas do mapa
  const [marker, setMarker] = useState(null); // Marcador no mapa
  const [processStatus, setProcessStatus] = useState(null); // Snapshot amigável de processamento
  const [retryProcessingSearch, setRetryProcessingSearch] = useState(null); // Callback para reexecutar busca com force_refresh

  // Estados para dados geográficos auxiliares
  const [municipios, setMunicipios] = useState([]);
  const [estados, setEstados] = useState(null);

  // Carrega estados ao montar o provider
  useEffect(() => {
    let isMountedEstados = true;
    fetch(
      'https://servicodados.ibge.gov.br/api/v4/malhas/paises/BR?formato=application/vnd.geo+json&qualidade=maxima&intrarregiao=UF',
    )
      .then((res) => res.json())
      .then((data) => {
        if (isMountedEstados) setEstados(data);
      })
      .catch((err) => console.error('[MapContext] Erro ao carregar estados:', err));
    return () => {
      isMountedEstados = false;
    };
  }, []);

  // Limpa dados da propriedade quando desmonta o componente
  useEffect(() => {
    return () => {
      setPropertyData(null);
      setGeometries([]);
    };
  }, []);

  const value = {
    // Estados essenciais para a funcionalidade principal
    propertyData,
    setPropertyData,
    geometries,
    setGeometries,
    themeGeometries,
    setThemeGeometries,
    loading,
    setLoading,
    error,
    setError,
    propertyCodes,
    setPropertyCodes,
    handlePropertyResult,
    setHandlePropertyResult,

    // Estados para controle da UI
    sidebarOpen,
    setSidebarOpen,
    activeLayers,
    setActiveLayers,
    marker,
    setMarker,
    processStatus,
    setProcessStatus,
    retryProcessingSearch,
    setRetryProcessingSearch,

    // Estados para dados geográficos auxiliares
    municipios,
    setMunicipios,
    estados,
    setEstados,
  };

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
}
